import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { Provider } from "react-redux";
import {LoaderProvider} from "./Utils/Loader";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <Provider store={store}>
          <LoaderProvider>
              <GoogleReCaptchaProvider reCaptchaKey={"6LdXydUqAAAAAL5rEU4zqDPPrZWYk-P2JSLW-d41"}>
                  <App />
              </GoogleReCaptchaProvider>
          </LoaderProvider>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
